import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy
} from '@angular/core';
import { filter, Subscription } from 'rxjs';
import {
  getLayerThematicColours,
  getLayerThematicOtherColours,
  isIconLayer,
  isLayerSpotlightSupported
} from 'src/app/shared/atlas-mapping/helpers/map-Legend-helper';
import { MapLayerStyleService } from 'src/app/shared/atlas-mapping/services/map-layer-style-service';
import {
  iconSizeDomain$,
  getLastIconSizeDomain
} from 'src/app/shared/atlas-mapping/helpers/thematic-style-helper';
import { LegendItem } from 'src/app/shared/atlas-mapping/models/legend-item';

@Component({
  selector: 'atlas-layer-legend-detail',
  templateUrl: './layer-legend-detail.component.html',
  styleUrls: ['./layer-legend-detail.component.less'],
  standalone: false
})
export class LayerLegendDetailComponent implements OnInit, OnDestroy {
  @Input() layer: any;
  @Output() legendItemClick = new EventEmitter<string>();

  spotlightedDomains: Set<string> = new Set();
  isSpotlightSupported = false;

  minIconSize: number | null = null;
  maxIconSize: number | null = null;

  private subscription: Subscription = new Subscription();

  constructor(private layerStyleService: MapLayerStyleService) {}

  ngOnInit() {
    this.isSpotlightSupported = isLayerSpotlightSupported(this.layer);

    if (this.isSpotlightSupported) {
      var colours = getLayerThematicColours(this.layer);
      var othersColours = getLayerThematicOtherColours(this.layer);

      this.layerStyleService.initializeSpotLightLayerColors(
        this.layer.id,
        colours,
        othersColours
      );

      if (isIconLayer(this.layer)) {
        var icons = this.layer.props.icons;
        this.layerStyleService.initializeSpotLightLayerIcons(
          this.layer.id,
          icons
        );
      }
    }

    this.spotlightedDomains =
      this.layerStyleService.getSpotlightedDomainsOnLayer(this.layer.id);

    if (this.layer?.props?.iconSizeAttribute) {
      this.subscription.add(
        iconSizeDomain$
          .pipe(filter((update) => update.layerId === this.layer.id))
          .subscribe(({ min, max }) => {
            this.minIconSize = min;
            this.maxIconSize = max;
          })
      );
      const lastDomain = getLastIconSizeDomain(this.layer.id);
      if (lastDomain) {
        this.minIconSize = lastDomain.min;
        this.maxIconSize = lastDomain.max;
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  onLegendItemClick(domain: string) {
    this.legendItemClick.emit(domain);
  }

  isSelected(domain: string | number): boolean {
    return this.spotlightedDomains.has(String(domain));
  }

  shouldApplyFilter(legendInfo: LegendItem): boolean {
    if (!this.layer || !this.layer.props) return false;
    return !!this.layer.props.iconMask;
  }
}
